export const sms = {
  state: {
    smsId: null,
    devCode: null,
    userSmsCode: null,
    expireTimestamp: null,
    sendErrorCode: null
  },
  mutations: {
    setSmsInfo(state, val) {
      state.smsId = val.smsId
      state.devCode = val.smsCode
      state.expireTimestamp = (Date.now() + (val.secondsLeft * 1000)) //secondsLeft сразу преобразуем в UNIX timestamp даты истечения срока действия кода
    },
    setUserSmsCode(state, val) {
      state.userSmsCode = val
    },
    setSmsErrorCode(state, val) {
      state.sendErrorCode = val
    }
  },
  getters: {
    smsId(state) {
      return state.smsId
    },
    smsDevCode(state) {
      return state.devCode
    },
    smsErrorCode(state) {
      return state.sendErrorCode
    },
    smsExpireTimestamp(state) {
      return state.expireTimestamp
    },
    userSmsCode(state) {
      return state.userSmsCode
    }
  }
}
